module.exports = __webpack_public_path__ + "media/bootstrap-icons/layout-wtf-3ad923e9.svg";